<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
      <div class="d-flex justify-end align-center">
        <v-btn
          class="mr-3"
          color="primary"
          small
          rounded
          depressed
          @click="openAddSubrecipeDialog"
        >
          Agregar subreceta
        </v-btn>
      </div>
      <div class="d-flex justify-end align-center">
        <v-btn
          class="mr-3"
          color="primary"
          small
          rounded
          depressed
          @click="openAddProductDialog"
        >
          Agregar producto
        </v-btn>
      </div>
    </div>

    <v-flex xs12>
      <v-skeleton-loader v-show="overlay" type="table" />
      <v-form v-show="!overlay" ref="inventory" v-model="isValid">
        <v-data-table
          :loading-text="table.title"
          :server-items-length="table.total"
          :headers="table.headers"
          :items="table.data"
          :options="table.options"
          sort-by="name"
          @update:options="updateTable"
          :footer-props="table.footer"
          class="elevation-1 d-print">
          <template v-slot:item.onModel="{ item }">
            <v-chip
              :color="getColor(item.onModel)"
              dark
              small
            >
              <div v-if="item.onModel === 'Product'">
                Producto
              </div>
              <div v-else>
                Subreceta
              </div>
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-end">
              <v-tooltip left>
                <template
                  v-slot:activator="{ on }">
                  <v-btn
                    class="mr-2"
                    fab
                    x-small
                    color="primary"
                    v-on="on"
                    @click="onUpdateProductDialog(item)" >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span v-if="item.onModel === 'Product'">Editar producto</span>
                <span v-else>Editar subreceta</span>
              </v-tooltip>
              <v-tooltip left>
                <template
                  v-slot:activator="{ on }">
                  <v-btn
                    color="error"
                    fab
                    x-small
                    v-on="on"
                    @click="onRemoveProductDialog(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span v-if="item.onModel === 'Product'">Eliminar producto</span>
                <span v-else>Eliminar subreceta</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-form>
    </v-flex>

    <v-dialog
      @keydown.esc="addProductDialog=false"
      v-model="addProductDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Agregar producto para inventariar
        </v-card-title>
        <v-card-text>
          <v-form ref="addProduct">
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center pa-3">
                  <div class="mr-3" v-if="!form.updating">
                    Filtros:
                  </div>
                  <div class="mr-3" v-if="!form.updating">
                    <v-menu
                      ref="datePicker"
                      v-model="datePicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="range"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          hide-details
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dates"
                        :range="true"
                        first-day-of-week="1"
                        no-title
                        :max="untilNow"
                      >
                        <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                        <v-spacer/>
                        <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                        <v-btn :disabled="dates.length < 2" color="primary" @click="datePicker = false">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <v-autocomplete
                  v-if="!form.updating"
                  v-model="search.products.field"
                  :items="search.products.items"
                  :loading="search.products.loading"
                  item-text="name"
                  item-value="_id"
                  :disabled="!this.dates[0] && !this.dates[1]"
                  label="Busca el producto para dar seguimiento"
                  clearable
                  hide-selected
                  hide-no-data
                  @change="productSelected($event)"
                  @input.native="searchProduct($event)"
                />
                <div v-else>
                  <div class="caption">
                    Producto:
                  </div>
                  <div class="subtitle-1">
                    {{ form.name }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="form.unit"
                  :items="forInventory"
                  label="Selecciona la unidad de medida del producto"
                  item-text="name"
                  item-value="uuid"
                  clearable
                  hide-selected
                  hide-no-data
                />
              </v-col>
              <v-col cols="12">
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
           @click="closeAddProductDialog">
            Cancelar
          </v-btn>
          <v-btn
            v-if="!form.updating"
            color="primary"
           @click="createInput(false)">
            De acuerdo
          </v-btn>
          <v-btn
            v-else
            color="primary"
           @click="updateInput(false)">
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="addSubrecipeDialog=false"
      v-model="addSubrecipeDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Agregar subreceta para inventariar
        </v-card-title>
        <v-card-text>
          <v-form ref="addSubrecipe">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-if="!form.updating"
                  v-model="search.subrecipes.field"
                  :items="search.subrecipes.items"
                  :loading="search.subrecipes.loading"
                  item-text="name"
                  item-value="uuid"
                  label="Busca la subreceta para dar seguimiento"
                  clearable
                  hide-selected
                  hide-no-data
                  @change="subrecipeSelected($event)"
                  @input.native="searchSubrecipe($event)"
                />
                <div v-else>
                  <div class="caption">
                    Subreceta:
                  </div>
                  <div class="subtitle-1">
                    {{ form.name }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="form.unit"
                  :items="forInventory"
                  label="Selecciona la unidad de medida"
                  item-text="name"
                  item-value="uuid"
                  clearable
                  hide-selected
                  hide-no-data
                />
              </v-col>
              <v-col cols="12">
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
           @click="closeAddSubrecipeDialog">
            Cancelar
          </v-btn>
          <v-btn
            v-if="!form.updating"
            color="primary"
           @click="createInput(true)">
            De acuerdo
          </v-btn>
          <v-btn
            v-else
            color="primary"
           @click="updateInput(true)">
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="removeProductDialog=false"
      v-model="removeProductDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Eliminar producto para inventariar
        </v-card-title>
        <v-card-text>
           <v-row>
            <v-col md="1">
              <v-icon>mdi-alert</v-icon>
            </v-col>
            <v-col>
              <div>
                ¿Estás seguro que deseas eliminar el producto <b>{{ toDelete.name }}</b> en la unidad <b>{{ toDelete.unit }}</b> para dar seguimiento a su inventario?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
           @click="closeRemoveProductDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
           @click="removeInput(false)">
            De acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="removeSubrecipeDialog=false"
      v-model="removeSubrecipeDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Eliminar subreceta para inventariar
        </v-card-title>
        <v-card-text>
           <v-row>
            <v-col md="1">
              <v-icon>mdi-alert</v-icon>
            </v-col>
            <v-col>
              <div>
                ¿Estás seguro que deseas eliminar la subreceta <b>{{ toDelete.name }}</b> en la unidad <b>{{ toDelete.unit }}</b> para dar seguimiento a su inventario?
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            text
           @click="closeRemoveSubrecipeDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
           @click="removeInput(true)">
            De acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'TrackingProducts',
  data () {
    return {
      isValid: false,
      addProductDialog: false,
      addSubrecipeDialog: false,
      removeProductDialog: false,
      removeSubrecipeDialog: false,
      overlay: false,
      section: this.$i18n.t('inventory.trackingTitle'),
      loadedData: null,
      table: {
        title: this.$i18n.t('inventory.loading'),
        loading: true,
        headers: [
          { text: 'Nombre', value: 'name', sortable: true },
          { text: 'Tipo', value: 'onModel', sortable: false },
          { text: 'Unidad de contenido', value: 'unit.name', sortable: false },
          { text: 'Acciones', value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 50,
          page: 1
        },
        footer: {
          'items-per-page-options': [25, 50, 100, 200]
        }
      },
      search: {
        products: {
          field: '',
          items: [],
          loading: false,
          name: ''
        },
        subrecipes: {
          field: '',
          items: [],
          loading: false,
          name: ''
        }
      },
      form: {
        product: '',
        unit: ''
      },
      toDelete: {
        _id: '',
        name: '',
        unit: ''
      },
      datePicker: false,
      dates: []
    }
  },
  computed: {
    ...mapGetters({
      forInventory: 'login/units/forInventory'
    }),
    restaurant () {
      return this.$store.state.currentRestaurant.data._id
    },
    area () {
      return this.$store.state.area.id
    },
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    untilNow () {
      return moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    getColor (item) {
      if (item === 'Product') return 'primary'
      return 'secondary'
    },
    closeAddSubrecipeDialog () {
      this.$refs.addSubrecipe.resetValidation()
      this.form = {
        product: '',
        unit: ''
      }
      this.search.subrecipes.field = ''
      this.addSubrecipeDialog = false
    },
    closeAddProductDialog () {
      this.$refs.addProduct.resetValidation()
      this.form = {
        product: '',
        unit: ''
      }
      this.search.products.field = ''
      this.addProductDialog = false
      this.resetDate()
    },
    openAddSubrecipeDialog () {
      this.addSubrecipeDialog = true
    },
    openAddProductDialog () {
      this.addProductDialog = true
    },
    searchSubrecipe: debounce(async function (event) {
      this.search.subrecipes.loading = true
      if (event.target.value && event.target.value.length > 3) {
        const params = {
          name: `/${event.target.value}/i`,
          restaurant: this.restaurant,
          area: this.area,
          subrecipe: true,
          skip: 0,
          limit: 20
        }
        const subrecipes = await this.$api.get('/v1/recipes', params)
        this.search.subrecipes = {
          items: subrecipes.data,
          loading: false
        }
      }
    }, 800),
    async subrecipeSelected (event) {
      if (event) {
        this.form.product = event
      }
    },
    searchProduct: debounce(async function (event) {
      if (event.target.value && event.target.value.length > 3) {
        this.search.products.loading = true
        const startDate = this.$moment(this.dates[0]).startOf('day').toISOString()
        const endDate = this.$moment(this.dates[1]).startOf('day').toISOString()
        let params = {
          name: `/${event.target.value}/i`,
          startDate: startDate,
          endDate: endDate
        }
        const products = await this.$api.get(`/v1/restaurants/${this.restaurant}/products`, params)
        if (!products.length) this.$toasted.show('No se encontró el producto en las fechas especificadas.', { duration: 3000 })
        this.search.products = {
          items: products,
          loading: false
        }
      }
    }, 800),
    async productSelected (event) {
      if (event) {
        this.form.product = event
      }
    },
    async createInput (isSubrecipe) {
      const payload = this.form
      payload.area = this.$store.state.area._id
      payload.isSubrecipe = isSubrecipe

      try {
        await this.$api.post(`/v1/inputs/tracking/create`, payload)
        await this.load({
          area: this.$store.state.area.id,
          limit: this.table.options.itemsPerPage,
          skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
          sort: 'name'
        })

        if (!isSubrecipe) {
          this.closeAddProductDialog()
          this.$toasted.show('El producto se agregó', { duration: 1500 })
        } else {
          this.closeAddSubrecipeDialog()
          this.$toasted.show('La subreceta se agregó', { duration: 1500 })
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async updateInput (isSubrecipe) {
      const payload = this.form
      payload.area = this.$store.state.area._id
      payload.isSubrecipe = isSubrecipe

      try {
        await this.$api.put(`/v1/inputs/tracking/${payload._id}/update`, payload)
        await this.load({
          area: this.$store.state.area.id,
          limit: this.table.options.itemsPerPage,
          skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
          sort: 'name'
        })
        if (!isSubrecipe) {
          this.closeAddProductDialog()
          this.$toasted.show('El producto se actualizó', { duration: 1500 })
        } else {
          this.closeAddSubrecipeDialog()
          this.$toasted.show('La subreceta se actualizó', { duration: 1500 })
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    onUpdateProductDialog (product) {
      this.form = {
        updating: true,
        _id: product._id,
        product: product.product._id,
        area: product.area._id,
        unit: product.unit._id,
        name: product.name
      }
      if (product.onModel === 'Product') {
        this.openAddProductDialog()
      } else {
        this.openAddSubrecipeDialog()
      }
    },
    onRemoveProductDialog (product) {
      this.toDelete = {
        _id: product._id,
        name: product.name,
        unit: product.unit.name
      }
      if (product.onModel === 'Product') {
        this.openRemoveProductDialog()
      } else {
        this.openRemoveSubrecipeDialog()
      }
    },
    openRemoveSubrecipeDialog () {
      this.removeSubrecipeDialog = true
    },
    openRemoveProductDialog () {
      this.removeProductDialog = true
    },
    closeRemoveSubrecipeDialog () {
      this.toDelete = {
        _id: '',
        name: '',
        unit: ''
      }
      this.removeSubrecipeDialog = false
    },
    closeRemoveProductDialog () {
      this.toDelete = {
        _id: '',
        name: '',
        unit: ''
      }
      this.removeProductDialog = false
    },
    async removeInput (isSubrecipe) {
      try {
        await this.$api.del(`/v1/inputs/tracking/${this.toDelete._id}/delete`)
        await this.load({
          area: this.$store.state.area.id,
          limit: this.table.options.itemsPerPage,
          skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
          sort: 'name'
        })

        if (!isSubrecipe) {
          this.closeRemoveProductDialog()
          this.$toasted.show('El producto se elimino', { duration: 1500 })
        } else {
          this.closeRemoveSubrecipeDialog()
          this.$toasted.show('La subreceta se elimino', { duration: 1500 })
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      await this.load({
        area: this.$store.state.area.id,
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`
      })
    },
    async load (params = null) {
      params = params || {
        area: this.$store.state.area.id,
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: 'name'
      }

      this.overlay = true
      try {
        const response = await this.$api.get('/v1/inputs', params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async resetDate () {
      this.dates = []
      await this.load()
      this.datePicker = false
    },
    filter: async function () {
      this.dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      this.datePicker = false
    }
  }
}
</script>

<style lang="scss">
.action-black {
  color: black !important;
}
.z-index--100 {
  z-index: 100 !important;
}
</style>
